import React from 'react';
import theme from './MaxLengthValidatingInput.module.scss';
import { InputProps } from '@/components/generic-controls/Input';
import { ValidatingInput, ValidationComponentProps } from '@ygtechnologies/bygr-frontend-component-library';

export type MaxLengthValidatingInputProps = InputProps & ValidationComponentProps & { maxLength: number; value: string };
/**
 * Same as props as ValidatingInput, but also includes a "counter" for how many letters you have remaining
 */
const MaxLengthValidatingInput: React.FC<MaxLengthValidatingInputProps> = ({ maxLength, value, ...rest }) => {
    return (
        <div className={theme.wrapper}>
            <ValidatingInput maxLength={maxLength} value={value} {...rest} />
            <span className={theme.number}>{maxLength - (value as string).length}</span>
        </div>
    );
};

export default MaxLengthValidatingInput;
